import { useAccounts } from 'hooks/banking/useAccounts'
import { DebitCardAccount } from 'types/accounts'
import { useTransferState } from 'pages/Transfer/Transfer.context'
import { TransferZellerFields } from 'pages/Transfer/Transfer.types'

export const useZellerTransferValues = () => {
  const { accountById } = useAccounts()

  const transferValues = useTransferState()
    .transferValues as TransferZellerFields

  const selectedFromAccount = accountById(
    transferValues.from ?? ''
  ) as DebitCardAccount
  const selectedToAccount = accountById(
    transferValues.to ?? ''
  ) as DebitCardAccount

  return {
    fromRecipient: selectedFromAccount,
    toRecipient: selectedToAccount,
    formValues: transferValues,
  }
}
